module.exports = __webpack_public_path__ + "static/img/choice.db41c87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supplychain/choice.png
// module id = GORM
// module chunks = 44